export const mockedSalaryRanges = {
  lastUpdated: '2025-08-12',
  salaryType: 'Annual',
  currency: 'AUD',
  salaryRange: [
    {
      roleTitle: 'Data Scientist',
      roleId: 'data-scientist',
      rangeByCompany: {
        minSalary: 120000,
        maxSalary: 180000,
        jobCount: 45,
      },
      rangeByIndustry: {
        minSalary: 110000,
        maxSalary: 200000,
        jobCount: 67,
      },
    },
    {
      roleTitle: 'Software Engineer',
      roleId: 'software-engineer',
      rangeByCompany: {
        minSalary: 110000,
        maxSalary: 150000,
        jobCount: 78,
      },
      rangeByIndustry: {
        minSalary: 100000,
        maxSalary: 190000,
        jobCount: 45,
      },
    },
    {
      roleTitle: 'DevOps Engineer',
      roleId: 'devops-engineer',
      rangeByCompany: {
        minSalary: 125000,
        maxSalary: 175000,
        jobCount: 32,
      },
      rangeByIndustry: {
        minSalary: 115000,
        maxSalary: 195000,
        jobCount: 28,
      },
    },
    {
      roleTitle: 'Product Manager',
      roleId: 'product-manager',
      rangeByCompany: {
        minSalary: 130000,
        maxSalary: 200000,
        jobCount: 56,
      },
      rangeByIndustry: {
        minSalary: 120000,
        maxSalary: 220000,
        jobCount: 89,
      },
    },
    {
      roleTitle: 'Product Designer',
      roleId: 'product-designer',
      rangeByCompany: {
        minSalary: 100000,
        maxSalary: 140000,
        jobCount: 23,
      },
      rangeByIndustry: {
        minSalary: 90000,
        maxSalary: 160000,
        jobCount: 34,
      },
    },
    {
      roleTitle: 'UX Researcher',
      roleId: 'ux-researcher',
      rangeByCompany: {
        minSalary: 105000,
        maxSalary: 145000,
        jobCount: 18,
      },
      rangeByIndustry: {
        minSalary: 95000,
        maxSalary: 165000,
        jobCount: 25,
      },
    },
    {
      roleTitle: 'Frontend Developer',
      roleId: 'frontend-developer',
      rangeByCompany: {
        minSalary: 95000,
        maxSalary: 135000,
        jobCount: 42,
      },
      rangeByIndustry: {
        minSalary: 85000,
        maxSalary: 155000,
        jobCount: 58,
      },
    },
    {
      roleTitle: 'Backend Developer',
      roleId: 'backend-developer',
      rangeByCompany: {
        minSalary: 105000,
        maxSalary: 145000,
        jobCount: 39,
      },
      rangeByIndustry: {
        minSalary: 95000,
        maxSalary: 165000,
        jobCount: 52,
      },
    },
    {
      roleTitle: 'Full Stack Developer',
      roleId: 'full-stack-developer',
      rangeByCompany: {
        minSalary: 100000,
        maxSalary: 140000,
        jobCount: 61,
      },
      rangeByIndustry: {
        minSalary: 90000,
        maxSalary: 160000,
        jobCount: 73,
      },
    },
    {
      roleTitle: 'Technical Lead',
      roleId: 'technical-lead',
      rangeByCompany: {
        minSalary: 140000,
        maxSalary: 190000,
        jobCount: 29,
      },
      rangeByIndustry: {
        minSalary: 130000,
        maxSalary: 210000,
        jobCount: 41,
      },
    },
    {
      roleTitle: 'Engineering Manager',
      roleId: 'engineering-manager',
      rangeByCompany: {
        minSalary: 150000,
        maxSalary: 220000,
        jobCount: 24,
      },
      rangeByIndustry: {
        minSalary: 140000,
        maxSalary: 250000,
        jobCount: 36,
      },
    },
    {
      roleTitle: 'QA Engineer',
      roleId: 'qa-engineer',
      rangeByCompany: {
        minSalary: 85000,
        maxSalary: 120000,
        jobCount: 31,
      },
      rangeByIndustry: {
        minSalary: 75000,
        maxSalary: 140000,
        jobCount: 47,
      },
    },
    {
      roleTitle: 'Systems Engineer',
      roleId: 'systems-engineer',
      rangeByCompany: {
        minSalary: 110000,
        maxSalary: 160000,
        jobCount: 21,
      },
      rangeByIndustry: {
        minSalary: 100000,
        maxSalary: 180000,
        jobCount: 33,
      },
    },
    {
      roleTitle: 'Cloud Engineer',
      roleId: 'cloud-engineer',
      rangeByCompany: {
        minSalary: 120000,
        maxSalary: 170000,
        jobCount: 37,
      },
      rangeByIndustry: {
        minSalary: 110000,
        maxSalary: 190000,
        jobCount: 49,
      },
    },
  ],
};
